import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { serviceStatus } from 'app/constants/csv/constants';
import { VehicleFluidSpecificationsModalComponent } from 'app/modules/technician/components/vehicle-fluid-specifications-modal/vehicle-fluid-specifications-modal.component';
import { DataService, DateService, HelperService, HTTPService } from 'app/services';
import { debounce, trim } from 'lodash';
import { DialogService } from 'primeng/dynamicdialog';
import { config, serviceStatusEnum } from 'app/constants';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components/confirm-dismiss-dialog/confirm-dismiss-dialog.component';
import { getEditorDefaults } from '@pqina/pintura';
import { ImageViewerProperties } from 'app/constants/csv/inspectionItemProperties';
import { datetimeFormat } from 'app/constants/date-time-format';
import { PinturaEditorComponent } from '@pqina/angular-pintura';
import { GalleryModalComponent } from '../gallery-modal/gallery-modal.component';
import * as RecordRTC from 'recordrtc';
import { MediaRecorder } from 'extendable-media-recorder';

import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-vehicle-inspection',
  templateUrl: './vehicle-inspection.component.html',
  styleUrls: ['./vehicle-inspection.component.scss']
})
export class VehicleInspectionComponent implements OnInit, OnDestroy {

  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('imageEditor') imageEditor: ElementRef;
  @ViewChild('pinturaEditor') pinturaEditor: PinturaEditorComponent<any>;
  @ViewChild('audioElement') audioElement: ElementRef<HTMLAudioElement>;
  @Input() isReadOnly: boolean = false;
  @Input() isFinalized: boolean = false;
  @Input() isModal: boolean = false;
  @Input() inspectionId: string = '';
  @Input() associatedInspectionId;
  @Input() inspectionItemId: string = '';
  @Input() estimateId: string = '';
  @Input() customer;
  @Input() service;
  @Input() isSidePanelOnly: boolean = false;
  @Input() customerLang: string = '';
  currentLang: string = 'en';
  @Output() closeModalEvent: EventEmitter<any> = new EventEmitter()
  editorDefaults: any = getEditorDefaults();
  subscriptions: Subscription[] = [];
  markupEditorToolStyles = ImageViewerProperties.markupEditorToolStyles;
  markupEditorShapeStyleControls = ImageViewerProperties.markupEditorShapeStyleControls;
  markupEditorToolbar = ImageViewerProperties.markupEditorToolbar;
  screenHeight: number;
  imagePreviewSize: HTMLElement;
  inspectionTitle: string = '';
  customerName: string = '';
  inspectionStatus: string = '';
  inspectionStatusClass: string = '';
  selectedInspectionNote: string = '';
  technicalNotes: string = '';
  selectedCategory: string = '';
  imageNotes: string = '';
  playingFormatedTime: string = '';
  selectedFileName: string = '';
  imageUrl: string = '';
  thumbnail: string = '';
  inspectionPoints: number = 0;
  totalWidthAssigned: number = 0;
  playingTime: number = 0;
  attachmentCount: number = 0;
  recordingTime: number = 0;
  windowWidth: number = 0;
  rowMaxWidth: number = 96;
  mobileWindow: number = 500;
  tabWindow: number = 1024;
  inspectionMark: object = {};
  isLoading: boolean = true;
  isFirstInspection: boolean = false;
  isLastInspection: boolean = false;
  isOverlaySidebarOpen: boolean = false;
  stopImmediateUpload: boolean = false;
  isEditNotes: boolean = true;
  editorEnabled: boolean = true;
  modalVisible: boolean = true;
  isVoiceUploading: boolean = false;
  showRecorder: boolean = false;
  isRecording: boolean = false;
  isIphone: boolean = false;
  isFromTech: boolean = false;
  isIpad: boolean = false;
  inspectionOverview = []
  audioAttachments = [];
  inspections = []
  inspectionsList = []
  uploadedFiles = []
  allConditions = []
  mediaRecorder = null;
  audioBlobs = [];
  capturedStream = null;
  vehicle;
  selectedInspection;
  actualInspection
  vehicleFluidData
  conditions
  selectedCondition
  menu
  notes
  textSaveTimeout
  playerTimeout
  playingAudio
  recorder;
  currentService;
  company: any = {}
  isMarkAllEnabledForDvi2: boolean = false;
  inspectionDifficulty: string = '';
  serviceId: string = '';
  itemId: string = '';
  isBackToStoreDetails: boolean = false;
  allMeasurements = [];
  measurements: any = []
  measurementInspectionIds: any = []
  debouncedUpdateInspection: Function;
  inspectionStatuses;
  missingInspectionItems: { 
    index: number, 
    name: string, 
    requirement: string, 
    categoryType: string,
    categoryIcon?: string
  }[] = [];
  showMissingFieldsError: boolean = false;
  isFilterViewActive: boolean = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private httpService: HTTPService,
    private dialogService: DialogService,
    private helperService: HelperService,
    private dataService: DataService,
    private dateService: DateService,
    private renderer: Renderer2,
    private translate: TranslateService
  ) {
    this.inspectionOverview = [
      {
        id: 'frontLeft',
        imgSrc: '',
        label: 'Front Left',
        labelFR: "Avant gauche"
      },
      {
        id: 'frontRight',
        imgSrc: '',
        label: 'Front Right',
        labelFR: "Avant droit"
      },
      {
        id: 'rearRight',
        imgSrc: '',
        label: 'Rear Right',
        labelFR: 'Arrière droit'
      },
      {
        id: 'rearLeft',
        imgSrc: '',
        label: 'Rear Left',
        labelFR: 'Arrière gauche'
      },
    ];
    this.menu = [
      {
        icon: 'assets/img/icon/cam.svg',
        name: 'Photo',
        nameFR: "Photo",
        type: 'image/*'
      },
      {
        icon: 'assets/img/icon/video.svg',
        name: 'Video',
        nameFR: "Vidéo",
        type: 'video/*'
      },
      // {
      //   icon: 'assets/img/icon/audio.svg',
      //   name: 'Audio',
      //   type: 'voice'
      // },
      {
        icon: 'assets/img/icon/gallery2.svg',
        name: 'Gallery',
        nameFR: "Gallerie",
        type: 'video/*,image/*'
      },
    ];
    this.inspectionStatuses = {
      TODO: 'todo',
      IN_PROGRESS: 'inProgress',
      COMPLETED: 'completed',
    }
    this.debouncedUpdateInspection = debounce(() => {
      this.updateInspection(this.selectedInspection._id, null, this.selectedInspection.status);
    }, 800);
  }

  async ngOnInit(): Promise<void> {
    this.isIphone = /^iP/.test(navigator.platform);
    this.isIpad = this.helperService.isIpad();
    this.setDataListener();
    this.helperService.hideBottomDetailsInTechApp.next(true);
    if (!this.inspectionId && !this.estimateId) {
      this.activatedRoute.params.subscribe(params => {
        this.inspectionId = params.inspectionId;
        this.estimateId = params.estimateId;
      })
    }

    this.activatedRoute.queryParams.subscribe((params: any) => {
      this.currentLang = this.customerLang || params['lang'] || 'en';
      this.serviceId = params['serviceId'] || '';
      this.itemId = params['itemId'] || '';
      this.isFromTech = params['isFromTech'] || false;
      this.isBackToStoreDetails = params['isBackToStoreDetails'] === 'true' ? true : false;
      this.translate.use(this.currentLang);
    });
    const promises = [];
    promises.push(this.getAndPopulateCompany());
    promises.push(this.httpService.getEstimateInspectionDetails(this.inspectionId, this.estimateId, true, true));

    [, this.actualInspection] = await Promise.all(promises)
    const inspectionData = this.helperService.deepCopy(this.actualInspection);

    const { employeeId } = this.helperService.getCompany();
    const isAssignedToCurrentUser = this.actualInspection?.estimateId?.services?.some(service =>
      service.inspection?.inspectionId === this.inspectionId && service.tech?.techId === employeeId
    );

    if (this.actualInspection &&
      this.actualInspection.inspectionStatus === this.inspectionStatuses.TODO &&
      isAssignedToCurrentUser &&
      this.isFromTech) {
      this.actualInspection.inspectionStatus = this.inspectionStatuses.IN_PROGRESS;
      await this.httpService.updateOrderInspection(this.actualInspection);
      this.dataService.sendData(
        this.dataService.typePassData('update-inspection-status', {
          inspectionId: this.inspectionId,
          status: this.inspectionStatuses.IN_PROGRESS
        })
      );
    }

    this.fetchVehicleFluidData(this.actualInspection?.estimateId?.vehicle?.vehicleId)
    this.actualInspection.associatedInspectionId = this.associatedInspectionId;
    this.inspectionStatus = this.actualInspection?.estimateId?.services[0]?.serviceStatus;
    this.vehicle = this.actualInspection?.estimateId?.vehicle;
    this.customerName = this.actualInspection?.customerId?.fullName ?? 'N/A';
    this.technicalNotes = this.actualInspection.notes ?? '';
    this.inspectionOverview = this.inspectionOverview.map(ins => {
      return {
        ...ins,
        imgSrc: this.vehicle?.vehicleImgs && this.vehicle?.vehicleImgs[ins.id] ? this.vehicle.vehicleImgs[ins.id] : ''
      }
    })
    this.inspectionStatusClass = serviceStatus[this.inspectionStatus]?.class;
    this.inspectionPoints = this.actualInspection?.category?.reduce((acc, val) => {
      acc += val?.inspectionItems?.length ?? 0
      return acc;
    }, 0)
    this.inspectionTitle = this.currentLang === 'fr' ? (this.actualInspection?.titleFR || this.actualInspection?.title) : (this.actualInspection?.title || this.actualInspection?.titleFR);
    this.setInspections()
    this.inspectionsList = this.inspections.reduce((accumulated, inspectionCategory) => {
      const ids = inspectionCategory?.items?.map(inspection => inspection.id);
      accumulated = [...accumulated, ...ids]
      return accumulated;
    }, [])
    this.setConditions(true);

    if (!this.isModal) {
      this.startService();
    }

    if (this.isSidePanelOnly) this.toggleInspection(this.inspectionItemId);
    this.isLoading = false;

    if (this.dataService.isTireStorage2Enabled) {
      if (inspectionData?.isTireStorageInspection) {
        this.isReadOnly = false;
      }
    }

    this.actualInspection?.category.forEach((catItem) => {
  catItem.inspectionItems.forEach((insItem)=>{
    insItem.measurementSection.forEach((measurementItem)=>{

      if (measurementItem.notes.length > 0 && !insItem?.measurement?.length) {
        this.measurementInspectionIds = [...this.measurementInspectionIds,measurementItem.notes[0]._id]
          }
        })
      });
    });

    setTimeout(() => {
      const missingItems = this.validateInspection();
      if (missingItems.length > 0) {
        this.showMissingFieldsError = true;
        
        const groupedMissingItems = missingItems.reduce((acc, item) => {
          if (!acc[item.categoryType]) {
            acc[item.categoryType] = {
              type: item.categoryType,
              icon: item.categoryIcon,
              items: []
            };
          }
          acc[item.categoryType].items.push(item);
          return acc;
        }, {});
        
        this.missingInspectionItems = Object.values(groupedMissingItems);
      }
    }, 500);       
 }

 ngAfterViewChecked() {
  this.windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
 }

  isAssignedToCurrentUser(): boolean {
    const { employeeId } = this.helperService.getCompany();
    return this.service?.tech?.techId === employeeId;
  }

  setInspections(){
        this.inspections = this.actualInspection?.category?.map((cat, outerIndex) => {
      if (cat) {
        return {
          id: cat.categoryId,
          type: this.currentLang === 'fr' ? (cat.titleFR || cat.title) : (cat.title || cat.titleFR),
          icon: cat.iconUrl || cat.icon || null,
          items: cat.inspectionItems.map((item, innerIndex) => ({
            id: item._id,
            label: this.currentLang === 'fr' ? (item.titleFR || item.title) : (item.title || item.titleFR),
            galleryCount: item.attachments?.length,
            status: item.colorIndex,
            conditions: item.conditions,
            selectedConditions: item.conditions?.filter(cond => cond.isSelected) ?? [],
            note: item.notes,
            measurement: item.measurement,
            errorMessage: this.inspections[outerIndex]?.items[innerIndex]?.errorMessage,
            showError: this.inspections[outerIndex]?.items[innerIndex]?.showError,
          }))
        }
      }
    }).filter(d => d);
  }

  setMeasurementPayload() {
    this.measurements = this.selectedInspection?.measurement || [];
  }

  setMeasurementInspectionIds(){
    if(this.selectedInspection?.measurement?.length){
      this.selectedInspection?.measurement?.forEach((section) => {
      this.measurementInspectionIds.push(section.id)
      });
    }
  }

  async getAndPopulateCompany() {
    try {
      const response = await this.httpService.getCompanyDetails(this.helperService.getCompany().companyId, 'fetchDaylightSavingStatus=true&fetchTimezones=true');
      this.company = response
      if (!response.appsettings.isMultiLocationEnabled) {
        this.isMarkAllEnabledForDvi2 = response?.appsettings?.isMarkAllEnabledForDvi2
        this.inspectionDifficulty = response?.appsettings?.inspectionsDifficulty
      }
      else {
        this.isMarkAllEnabledForDvi2 = response?.shop?.appsettings?.isMarkAllEnabledForDvi2
        this.inspectionDifficulty = response?.shop?.appsettings?.inspectionsDifficulty
      }

    } catch (err) {
      this.helperService.showToaster('error', err);
    }
  }

  handleMediaRemoval(attachmentId) {
    if (this.selectedInspection) {
      this.selectedInspection.attachments = this.selectedInspection.attachments.filter(
        att => att._id !== attachmentId
      );
      this.updateInspection(null, null, null, null, this.selectedInspection.attachments);
    }
  }

  handleMultiChange(inspectionName) {
    const markingOn = !this.inspectionMark[inspectionName];

    this.inspectionMark[inspectionName] = markingOn;

    this.inspections = this.inspections.map((inspection, outerIndex) => {
      if (inspection.type === inspectionName) {
        return {
          ...inspection,
          items: inspection.items.map((item, innerIndex) => {
            return {
              ...item,
              status: markingOn ? 0 : item.status === 0 ? -1 : item.status,
              errorMessage: this.inspections[outerIndex]?.items[innerIndex]?.errorMessage,
              showError: this.inspections[outerIndex]?.items[innerIndex]?.showError,
            };
          })
        };
      } else {
        return { ...inspection };
      }
    });

    this.actualInspection.category = this.actualInspection.category.map(category => {
      if (category.title === inspectionName || category.titleFR === inspectionName) {
        return {
          ...category,
          inspectionItems: category.inspectionItems.map(item => ({
            ...item,
            colorIndex: markingOn ? 0 : item.colorIndex === 0 ? -1 : item.colorIndex,
          }))
        };
      } else {
        return category;
      }
    });

    this.updateInspection(null, inspectionName, null);
  }

  nameCreater(name) {
    const tokens = name?.split('%24-%24');
    const doTokens = name?.split('.');
    if (doTokens?.length) {
      return tokens[0]?.split('.')?.length > 1 ? `${tokens[0]}` : `${tokens[0]}.${doTokens[doTokens.length - 1]}`
    } else {
      return name;
    }
  }

  openView() {
    if(this.vehicleFluidData && this.actualInspection?.estimateId?.vehicle?.vehicleId && this.vehicle){
      const ref = this.dialogService.open(VehicleFluidSpecificationsModalComponent, {
        width: '90%',
        styleClass: 'small-heading-dialog vehicle-specs',
        showHeader: false,
        data: {
          specs: this.vehicleFluidData,
          vehicleId: this.actualInspection?.estimateId?.vehicle?.vehicleId,
        },
      });
      
      ref.onClose.subscribe(({ isClose }) => { })
    }
    else{

      this.helperService.showToaster('error', 'Please add customer and Vehicle');
    }

  }

  fetchVehicleFluidData(vehicleId: any) {
    this.httpService.getVehicleFluidSpecifications(vehicleId).then((data: any) => {
      this.vehicleFluidData = data.fliudSpecs || null;
    });
  }

  handleChange(event) {
    if (this.textSaveTimeout) {
      clearTimeout(this.textSaveTimeout)
    }

    this.textSaveTimeout = setTimeout(() => {
      this.updateVehicleOverviewSection(event)
    }, 500);
  }

  inspectionNoteChange(event) {
    if (this.textSaveTimeout) {
      clearTimeout(this.textSaveTimeout)
    }

    this.textSaveTimeout = setTimeout(() => {
      const note = typeof event === 'string' ? event : event?.target?.value ?? '';
      this.updateInspection(null, null, null, note)
    }, 500);
  }

  removeImg(id) {
    this.vehicle.vehicleImgs[id] = "";
    this.updateVehicleOverviewSection();

    setTimeout(() => {
      this.updateMissingItems();
      const missingItems = this.validateInspection();
      this.showMissingFieldsError = missingItems.length > 0;
    }, 100);
  }

  handleStatus(id, status) {
    let item;
    for (const category of this.actualInspection?.category || []) {
      item = category.inspectionItems.find(ins => ins._id === id);
      if (item) break;
    }
    if (!item) return;
    const canDeselect = item.colorIndex > -1;
    let statusChanged = false;
    this.inspections.forEach(inspection => {
      inspection.items.forEach(item => {
        if (item.id === id) {
          if (item.status === status) {
            if (canDeselect) {
              item.status = -1;
              status = -1;
              statusChanged = true;
            }
          } else {
            item.status = status;
            statusChanged = true;
          }
        }
      });
    });
    if (statusChanged) {
      this.updateInspection(id, null, status);
      this.refreshInspectionItems();
      this.updateMissingItems();
    }
    if (!this.isOverlaySidebarOpen && status >= 1) {
      this.toggleInspection(id);
    }
  }
  canDeselectItem(item, newStatus): boolean {
    if (!item.isRequired && !item.isMediaRequired && !this.actualInspection?.mediaForYRItems) {
      return true;
    }

    const hasMedia = item.attachments && item.attachments.length > 0;
    const isYellowOrRedStatus = newStatus === 1 || newStatus === 2;

    if (item.isRequired) {
      if (!this.actualInspection?.mediaForYRItems) {
        return newStatus === 0 && !hasMedia;
      }

      if (isYellowOrRedStatus) {
        return !hasMedia;
      }

      return newStatus === 0;
    }

    if (item.isMediaRequired) {
      return !(hasMedia && newStatus > -1);
    }

    if (this.actualInspection?.mediaForYRItems) {
      if (isYellowOrRedStatus) {
        return !hasMedia;
      }

      return newStatus === 0;
    }

    return true;
  }

  updateInspection(id?: string, inspectionName?: string, status?: number, notes?: string, attachments?) {
    this.actualInspection.category = this.actualInspection.category.map(inspection => {
      if (id) {
        return {
          ...inspection,
          inspectionItems: inspection.inspectionItems.map(item => {
            if (item._id === id) {
              return {
                ...item,
                colorIndex: status,
              }
            } else {
              return {
                ...item
              }
            }
          })
        }
      } else if (inspectionName) {
        if (inspection.title === inspectionName) {
          return {
            ...inspection,
            inspectionItems: inspection.inspectionItems.map(item => ({
              ...item,
              colorIndex: this.inspectionMark[inspectionName] ? item.colorIndex < 0 ? 0 : item.colorIndex : item.colorIndex === 0 ? -1 : item.colorIndex,
            }))
          }
        } else {
          return {
            ...inspection
          }
        }
      } else if (notes !== null && notes !== undefined) {
        return {
          ...inspection,
          inspectionItems: inspection.inspectionItems.map(item => {
            if (item._id === this.selectedInspection._id) {
              return {
                ...item,
                notes,
              }
            } else {
              return {
                ...item
              }
            }
          })
        }
      } else if (attachments?.length) {
        return {
          ...inspection,
          inspectionItems: inspection.inspectionItems.map(item => {
            if (item._id === this.selectedInspection._id) {
              return {
                ...item,
                attachments,
              }
            } else {
              return {
                ...item
              }
            }
          })
        }
      } else {
        return {
          ...inspection
        }
      }
    })
    if (this.measurements.length) {
      this.actualInspection.category.forEach((categoryItem) => {
        const inspectionItems = categoryItem.inspectionItems;
        inspectionItems.forEach((inspectionItem) => {
          if (inspectionItem._id === this.measurements[0].inspectionId) {
            inspectionItem.measurement = this.measurements
          }
        });
      });
    }
    this.httpService.updateOrderInspection(this.actualInspection)
    this.setMeasurements()
    this.setMeasurementInspectionIds()
    if (!notes) {
      if (this.selectedInspection) {
        this.setSelectedInspection(this.selectedInspection._id)
      }

      const missingItems = this.validateInspection();
      this.inspections = this.actualInspection?.category?.map((cat, outerIndex) => {
        if (cat) {
          return {
            id: cat.categoryId,
            type: cat.title,
            icon: cat.iconUrl || null,
            items: cat.inspectionItems.map((item, innerIndex) => {
              return {
                id: item._id,
                label: this.currentLang === 'fr' ? (item.titleFR || item.title) : (item.title || item.titleFR),
                galleryCount: item.attachments?.length,
                status: item.colorIndex,
                conditions: item.conditions,
                selectedConditions: item.conditions?.filter(cond => cond.isSelected) ?? [],
                note: item.notes,
                measurement: item.measurement,
              };
            })
          };
        }
      }).filter(d => d);
      this.showMissingFieldsError = missingItems.length > 0;
      this.updateMissingItems();
    }
  }

  addCannedNote(note) {
    this.selectedInspectionNote += ` ${note}`;
    this.inspectionNoteChange(this.selectedInspectionNote)
  }
  selectCondition(condition) {
    this.selectedCondition = condition;
    this.conditions = this.conditions.map(cond => {
      return {
        ...cond,
        isSelected: cond.name === condition.name ? !cond.isSelected : cond.isSelected
      }
    });
    this.notes = this.conditions.reduce((acc, cond) => {
      if (cond.isSelected) {
        if (this.currentLang === 'fr' && cond.cannedNotesFR.length > 0) {
          const condFrench = cond.cannedNotesFR.filter((note: string) => note);
          if (this.currentLang === 'fr' && condFrench.length > 0) {
            acc = [...acc, ...condFrench]
          } else {
            acc = [...acc, ...cond.cannedNotes]
          }
        } else {
          acc = [...acc, ...cond.cannedNotes]
        }
      }
      return acc
    }, []);
    this.selectedInspection.conditions.map(cond => {
      if (cond._id === condition._id) {
        return {
          ...cond,
          isSelected: !cond.isSelected
        }
      } else {
        return {
          ...cond
        }
      }
    })
    for (const category of this.actualInspection.category) {
      if (category.title === this.selectedCategory || category.titleFR === this.selectedCategory) {
        for (const item of category.inspectionItems) {
          if (item._id === this.selectedInspection._id) {
            for (const condition of item.conditions) {
              if (condition._id === this.selectedCondition._id) {
                condition.isSelected = !condition.isSelected
              }
            }
          }
        }
      }
    }
    this.inspections = this.actualInspection?.category?.map((cat, outerIndex) => {
      if (cat) {
        return {
          id: cat.categoryId,
          type: cat.title,
          icon: cat.iconUrl || null,
          items: cat.inspectionItems.map((item, innerIndex) => ({
            id: item._id,
            label: this.currentLang === 'fr' ? (item.titleFR || item.title) : (item.title || item.titleFR),
            galleryCount: item.attachments?.length,
            status: item.colorIndex,
            conditions: item.conditions,
            selectedConditions: item.conditions?.filter(cond => cond.isSelected) ?? [],
            note: item.notes,
            measurement: item.measurement,
            errorMessage: this.inspections[outerIndex]?.items[innerIndex]?.errorMessage,
            showError: this.inspections[outerIndex]?.items[innerIndex]?.showError,
          }))
        }
      }
    }).filter(d => d);
    this.httpService.updateOrderInspection(this.actualInspection)
    this.setConditions();
  }


  toggleInspection(inspectionId?: string) {
    if (inspectionId && !this.isOverlaySidebarOpen) {
      this.setSelectedInspection(inspectionId);
      this.isOverlaySidebarOpen = true;
      let index = this.inspectionsList.findIndex(inspection => inspection === this.selectedInspection._id)
      this.isFirstInspection = index === 0;
      this.isLastInspection = index === this.inspectionsList.length - 1;
    }
    else {
      this.isOverlaySidebarOpen = !this.isOverlaySidebarOpen;
      if (!this.isOverlaySidebarOpen) {
        this.notes = [];
        this.refreshInspectionItems();
        this.selectedInspection = null;
        setTimeout(() => { }, 0);
        if (this.showMissingFieldsError) {
          this.updateMissingItems();
        }
      }
    }
    this.setMeasurements();
    this.setMeasurementInspectionIds()
    this.setMeasurementPayload()
    this.setInspections()    
  }

  refreshInspectionItems() {
    this.inspections = this.actualInspection?.category?.map((cat, outerIndex) => {
      if (cat) {
        return {
          id: cat.categoryId,
          type: this.currentLang === 'fr' ? (cat.titleFR || cat.title) : (cat.title || cat.titleFR),
          icon: cat.iconUrl || cat.icon || null,
          items: cat.inspectionItems.map((item, innerIndex) => ({
            id: item._id,
            label: this.currentLang === 'fr' ? (item.titleFR || item.title) : (item.title || item.titleFR),
            galleryCount: item.attachments?.length,
            status: item.colorIndex,
            conditions: item.conditions,
            selectedConditions: item.conditions?.filter(cond => cond.isSelected) ?? [],
            note: item.notes,
            errorMessage: this.inspections[outerIndex]?.items[innerIndex]?.errorMessage,
            showError: this.inspections[outerIndex]?.items[innerIndex]?.showError,
          }))
        }
      }
    }).filter(d => d);
  }

  setDataListener() {
    this.subscriptions.push(
      this.dataService.getData().subscribe(({ data }) => {
        if (!data) {
          return;
        }
        const { key } = data;
        if (key === 'trigger-service-status-update') {
          const { serviceData } = data.data.data;
          serviceData.forceClockIn = true;
          if (serviceData) {
            this.httpService.updateClockStatus({ isClockIn: true, forceUpdate: false }).then(() => {
              this.updateStatus({ ...serviceData });
            })
          }
        } else if (key === 'unauthorized-service-success') {
          const { serviceData } = data.data;
          serviceData.fromTimer = true;
          if (serviceData && serviceData.fromTimer) {
            this.updateStatus({ ...serviceData.data, forceStart: true });
          }
        } else if (key === 'trigger-vin-success') {
          const serviceData = data.data;
          if (serviceData && serviceData.status === 'inprogress') {
            this.updateStatus({ ...serviceData, estimateId: this.estimateId });
          }
        }
      })
    )
  }


  startService() {
    const inspectionId = this.activatedRoute.snapshot.paramMap.get('inspectionId');
    this.actualInspection?.estimateId?.services?.forEach(service => {
      if (service?.inspection?.inspectionId === inspectionId) {
        this.currentService = service;
      }
    })
    this.httpService.getActiveService().then(
      (res) => {
        if (res) {
          const forceClockIn = false;
          const { currentActiveService } = res;
          if (this.currentService?._id) {
            if (currentActiveService?._id) {
              if (this.currentService?.status !== 'inprogress' && this.currentService?.status !== 'completed') {
                this.updateStatus({
                  title: this.currentService.title,
                  estimateId: this.estimateId,
                  workId: this.currentService._id,
                  workType: 'service',
                  isClockIn: true,
                  // override: true,
                  status: 'inprogress',
                  // forceStart: true,
                  forceClockIn,
                }, false)
              }
            } else {
              if (serviceStatusEnum.indexOf(this.currentService.status) !== -1) {
                this.updateStatus({
                  forceClockIn,
                  title: this.currentService.title,
                  estimateId: this.estimateId,
                  workId: this.currentService._id,
                  workType: 'service',
                  status: this.currentService.status === 'inprogress' ? 'pause' : 'inprogress',
                  isClockIn: true,
                }, false);
              }
            }
          }
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  /** Showing loaders and updating status */
  updateStatus(data: any, isMarkComplete?: any) {
    this.httpService.serviceAction(this.currentService.orderId || (data && data.estimateId), data).then(
      (res: any) => {
        if (res && res.msg === 'Already inprogress.') {
          this.openConfirmForceStartDialog(res.data || {});
        } else if (res && res.msg === 'clock-out') {
          const { tech, status, title } = this.currentService;
          this.dataService.sendData(
            this.dataService.typePassData('check-for-service-editable', {
              type: 'service',
              status,
              tech,
              triggerFrom: 'timer',
              data: {
                techName: (tech && tech.name) || '',
                serviceTitle: title,
                serviceData: { ...data }
              },
            })
          );
        } else if (res && res.isPendingService) {
          this.dataService.sendData(
            this.dataService.typePassData('unauthorized-service', {
              serviceData: { data, isMarkComplete },
            })
          );
        } else if (res && res.msg === 'no-vin') {
          this.dataService.sendData(
            this.dataService.typePassData('no-vin-found', {
              triggerFrom: 'timer',
              payload: { data },
              vehicle: res.vehicle,
              customer: res.customer,
              required: res.required,
            })
          );
        } else if (data.forceClockIn) {
          this.dataService.sendData(
            this.dataService.typePassData('trigger-service=success-toastr', {
              pStatus: this.currentService.status,
              nStatus: data.status,
            })
          );
        } else {
          this.dataService.sendData(this.dataService.typePassData('refetch-active-service', this.currentService));
          this.dataService.sendData(this.dataService.typePassData('trigger-employee-resync', {}));
          this.helperService.showToaster('success', this.currentLang === 'fr' ? `Ce service a été démarré` : `This service has been started`);
        }
      },
      (err) => {
        // this.helperService.showToaster('error', err);
      }
    );
  }

  /** Confirmation dialog for start force fully start service by stop the current inprogress one */
  openConfirmForceStartDialog({ title, workType }) {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '90%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        title: this.currentLang === 'fr' ? 'Confirmation' : 'Confirmation',
        message: this.currentLang === 'fr'
          ? `Êtes-vous sûr de vouloir démarrer ce service, démarrer cela mettra en pause le "${title}" ${workType} qui est en cours?`
          : `Are you sure you want to start this service, starting this will pause the "${title}" ${workType} which is in progress?`,
        button: {
          success: { title: this.currentLang === 'fr' ? 'Démarrer' : 'Start' },
          cancel: { title: this.currentLang === 'fr' ? 'Annuler' : 'Cancel' },
        },
      },
    });
    const onCloseSub = ref.onClose.subscribe((confirm) => {
      if (confirm.isSuccess) {
        this.updateStatus({
          title: this.currentService.title,
          estimateId: this.estimateId,
          workId: this.currentService._id,
          workType: 'service',
          override: true,
          status: 'inprogress',
          forceStart: true
        });
      }
      onCloseSub.unsubscribe();
    });
  }

  changeInspection(direction) {

    if (this.isLastInspection && direction === 1) {
      this.isLastInspection = false;
      this.toggleInspection();
    }

    let index = this.inspectionsList.findIndex(inspection => inspection === this.selectedInspection?._id);
    index = index + direction < 0 ? index : index + direction > this.inspectionsList.length - 1 ? index : index + direction;
    this.isFirstInspection = index === 0;
    this.isLastInspection = index === this.inspectionsList.length - 1;
    const changedInspectionId = this.inspectionsList[index];
    if (changedInspectionId) {
      this.setSelectedInspection(changedInspectionId);
    }
  }

  setSelectedInspection(inspectionId: string) {
    let inspection;
    for (const category of this.actualInspection?.category) {
      inspection = category?.inspectionItems?.find(ins => ins._id === inspectionId)
      if (inspection) {
        this.selectedCategory = this.currentLang === 'fr' ? category.titleFR || category.title : category.title || category.titleFR;
        break;
      }
    }
    if (inspection) {
      this.selectedInspection = {
        ...inspection,
        status: inspection.colorIndex
      };
      this.setMeasurements();
      this.audioAttachments = this.selectedInspection.attachments.reduce((acc, att) => {
        if (att.type === 'voice') {
          acc.push({
            ...att,
            play: false,
            pause: false,
            playingTime: false,
          })
        }
        return acc;
      }, []);
      this.showRecorder = false;
      this.attachmentCount = this.selectedInspection?.attachments?.filter(att => att.type === 'image' || att.type === 'video').length;
      this.uploadedFiles = this.selectedInspection?.attachments?.map(att => this.nameCreater(att.name));
      this.thumbnail = this.selectedInspection?.attachments.find(att => att.type === 'image' || att.type === 'video');
      setTimeout(() => {
        this.selectedInspectionNote = JSON.parse(JSON.stringify(this.selectedInspection.notes))
      }, 0);
      if (this.selectedInspection?.conditions?.length) {
        this.conditions = this.allConditions?.find(inspection => this.selectedInspection._id === inspection.id)?.conditions;
        this.notes = this.conditions.reduce((acc, cond) => {
          if (cond.isSelected) {
            acc = [...acc, ...cond.cannedNotes]
          }
          return acc
        }, []);
      } else {
        this.conditions = [];
        this.notes = [];
      }
    }
  }

  onFileSelected(id, event, type) {
    setTimeout(() => {
      let files;
      if (event?.target?.files) {
        files = event.target.files;
      } else if (event?.srcElement?.files) {
        files = event.srcElement.files;
      } else if (event?.currentTarget?.files) {
        files = event.currentTarget.files;
      } else if (event?.files) {
        files = event.files;
      }
      if (!files || !files[0]) return;
      this.selectedFileName = files[0].name;
      if (!this.helperService.isAppleDevice) {
        const isDuplicate = this.uploadedFiles?.some(file => file === this.selectedFileName?.split('-')?.join(''))
        if (isDuplicate) {
          this.helperService.showToaster('error', 'Duplicate files not allowed.');
          return
        }
      }
        if (!id && (type === 'image' || files[0].type.includes('image'))) {
        const reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = (_event) => {
          this.imageUrl = reader.result as string;
        };
      }
      let fileName: string = trim(files[0].name);
      fileName = fileName.replaceAll('-', '');

      if (this.isIphone) {
        fileName = `${fileName}${new Date().getTime()}`
      }
      const formData = new FormData();
      formData.append('file', files[0], fileName);
      if (type && type !== 'image' && !files[0].type.includes('image')) {
        this.httpService.uploadAttachment(formData, config.category.inspection, this.selectedInspection._id).then(
          (res: any) => {
            if (!this.selectedInspection.attachments?.length) {
              this.selectedInspection.attachments = [];
            }
            const attachmentObj = {
              type: files[0].type?.split('/')[0],
              createdAt: new Date(res.uploadAt).toISOString(),
              name: fileName,
              url: res.url,
              notes: "",
              createdBy: res.uploadBy,
            }

        
            const insId = res.key?.split('/')[3]

            if (insId === this.selectedInspection._id) {
              this.selectedInspection.attachments.push(attachmentObj);
            } else {
              this.actualInspection.category.forEach(category => {
                category.inspectionItems.forEach(item => {
                  if (item._id === insId) {
                    item.attachments.push(attachmentObj)
                  }
                })
              })
            }
            this.updateInspection(null, null, null, null, this.selectedInspection.attachments);
            this.refreshInspectionItems();
            this.updateMissingItems();
          },
          (err) => {
            this.helperService.showToaster('error', err);
          }
        );
      } else if (!type) {
        this.stopImmediateUpload = true;
        this.httpService.uploadAttachment(formData, config.category.inspection, `${this.estimateId}#${this.inspectionId}`).then(
          (res: any) => {
            const url = res.url;
            this.vehicle = {
              ...this.vehicle,
              vehicleImgs: {
                ...this.vehicle.vehicleImgs,
                [id]: url
              }
            };
            this.inspectionOverview = this.inspectionOverview.map(ins => ({
              ...ins,
              imgSrc: ins.id === id ? url : ins.imgSrc || (this.vehicle?.vehicleImgs && this.vehicle?.vehicleImgs[ins.id] ? this.vehicle.vehicleImgs[ins.id] : "")
            }));  
            this.updateVehicleOverviewSection();
            this.stopImmediateUpload = false;
            this.updateMissingItems();
          },
          (err) => {
            this.stopImmediateUpload = false;
            this.helperService.showToaster('error', err);
          }
        );
      }
    }, 500);
  }
  isOverviewImagesComplete(): boolean {
    if (!this.actualInspection?.overviewImgsRequired) {
      return true;
    }
    
    return !this.inspectionOverview.some(img => !img.imgSrc);
  }
  updateVehicleOverviewSection(note?: string) {
    if (note) {
      this.actualInspection.notes = note;
      this.httpService.updateOrderInspection(this.actualInspection);
    } else {
      this.httpService.updateVehicleInRO(this.estimateId, this.vehicle).then((response: any) => {
        this.inspectionOverview = this.inspectionOverview.map(ins => ({
          ...ins,
          imgSrc: response?.vehicleImgs[ins.id] ? response?.vehicleImgs[ins.id] : ""
        }))
        this.updateMissingItems();
        this.showMissingFieldsError = this.validateInspection().length > 0;
      });
    }
  }

  toggleDrawableModal() {
    this.isEditNotes = !this.isEditNotes;
  }

  hideEditor(discard = false) {
    if (discard) {
      const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
        width: '90%',
        styleClass: 'small-heading-dialog',
        showHeader: false,
        data: {
          title: this.currentLang === 'fr' ? 'Annuler les modifications?' : 'Discard edits?',
          message: this.currentLang === 'fr' ? `Si vous revenez maintenant, vous perdrez toutes les modifications que vous avez apportées.` : `If you go back now, you’ll lose all of the edits you’ve made.`,
          button: {
            success: { title: this.currentLang === 'fr' ? 'Annuler' : 'Discard' },
            cancel: { title: this.currentLang === 'fr' ? 'Continuer à éditer' : 'Keep editing' },
          },
        },
      });
      const onCloseSub = ref.onClose.subscribe((confirm) => {
        if (confirm.isSuccess) {
          this.imageNotes = '';
          this.hideEditor(false);
        }
        onCloseSub.unsubscribe();
      });
    } else {
      this.modalVisible = false;
      this.editorEnabled = false;
      this.imageUrl = '';
      this.isEditNotes = false;
      this.dataService.sendData({ key: 'show-toolbar' });
    }
  }

  handleImgNotesChange(value: string = '') {
    this.imageNotes = value;
  }

  handleEditorProcess(imageState: any): void {
    this.hideEditor(false);
    this.saveImage(imageState.dest);
  }

  saveImage(file: any) {
    // append actual name of the file with "$-$" special characters
    file = new File([file], this.selectedFileName, { type: file.type });
    const formData = new FormData();
    formData.append('file', file);
    let fileName: string = trim(file.name);
    fileName = fileName.replaceAll('-', '');
    // in case of iphone
    if (this.isIphone) {
      fileName = `${fileName}${new Date().getTime()}`
    }
    this.imageUrl = '';
    this.httpService.uploadAttachment(formData, config.category.inspection, this.selectedInspection._id).then(
      (res: any) => {
        if (!this.selectedInspection.attachments?.length) {
          this.selectedInspection.attachments = [];
        }
        const attachmentObj = {
          type: file.type?.split('/')[0],
          createdAt: new Date(res.uploadAt).toISOString(),
          name: fileName,
          url: res.url,
          notes: JSON.parse(JSON.stringify(this.imageNotes)),
          createdBy: res.uploadBy,
        }

        // at index 3 we have inspection id
        const insId = res.key?.split('/')[3]

        if (insId === this.selectedInspection._id) {
          this.selectedInspection.attachments.push(attachmentObj);
        } else {
          this.actualInspection.category.forEach(category => {
            category.inspectionItems.forEach(item => {
              if (item._id === insId) {
                item.attachments.push(attachmentObj)
              }
            })
          })
        }
        this.updateInspection(null, null, null, null, this.selectedInspection.attachments);
        this.refreshInspectionItems();
        this.imageNotes = '';
        this.selectedFileName = '';
        this.updateMissingItems();
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  handleLoadPreview() {
    this.editorEnabled = true;
    this.dataService.sendData({ key: 'hide-toolbar' });
  }

  handleOverlayLoad(event) {
    this.imagePreviewSize = this.imageEditor.nativeElement;
    this.screenHeight = window.innerHeight;
    this.setDivHeight();
    this.dataService.sendData({ key: 'hide-toolbar' });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.screenHeight = window.innerHeight;
    this.setDivHeight();
  }

  setDivHeight(): void {
    if (this.imagePreviewSize) {
      this.renderer.setStyle(this.imagePreviewSize, 'height', `${this.screenHeight - 70}px`);
    }

  }

  willProcessImage = async (): Promise<boolean> => {
    this.editorEnabled = false;
    this.isEditNotes = false;
    return true;
  };

  openGallery() {
    const mediaFiles = this.selectedInspection.attachments.filter(att => att.type === 'image' || att.type === 'video');
    const ref = this.dialogService.open(GalleryModalComponent, {
      width: '100%',
      styleClass: `small-heading-dialog ${this.windowWidth > 500 ? 'gallery' : 'gallery-small'}`,
      showHeader: false,
      data: {
        currentLang: this.currentLang,
        mediaFiles,
        selectedInspectionId: this.selectedInspection._id,
        inspection: this.actualInspection,
        isRemovingAllowed: !this.isFinalized,
      },
    });
    const onCloseSub = ref.onClose.subscribe((data) => {
      if (data) {
        const oldAttachmentCount = this.attachmentCount;

        this.selectedInspection.attachments = this.selectedInspection.attachments.filter(att => att.type !== 'image' && att.type !== 'video');
        if (data.mediaFiles) {
          this.selectedInspection.attachments = [...this.selectedInspection.attachments, ...data.mediaFiles];
        }

        this.attachmentCount = data.mediaFiles ? data.mediaFiles.length : 0;
        this.uploadedFiles = this.selectedInspection?.attachments?.map(att => this.nameCreater(att.name));
        this.thumbnail = this.selectedInspection?.attachments.find(att => att.type === 'image' || att.type === 'video');

        this.updateInspection(null, null, null, null, this.selectedInspection.attachments);
        this.refreshInspectionItems();
      }
      onCloseSub.unsubscribe();
    });
  }

  openRecorder(media) {
    if (media.type === 'voice') {
      this.showRecorder = !this.showRecorder;
      if (this.showRecorder) {
        this.voiceRecord()
      }
    }
    // this.fileInput.nativeElement.click();
  }

  playAudio(index: number) {
    // this.audioAttachments[index].play = !this.audioAttachments[index].play;
    if (!this.audioAttachments[index].play) {
      this.audioAttachments[index].play = true;
      if (!this.audioAttachments[index].pause) {
        this.playingAudio = new Audio(this.audioAttachments[index].url);
      }
      this.playingAudio.play();
      this.playingAudio.addEventListener('play', () => {
        this.playerTimeout = setInterval(() => {
          if (this.audioAttachments[index].playingTime < this.audioAttachments[index].recordingTime) {
            this.audioAttachments[index].playingTime += 1;
          } else {
            this.audioAttachments[index].play = false;
            this.audioAttachments[index].pause = false;
            this.audioAttachments[index].playingTime = 0;
            clearInterval(this.playerTimeout)
          }
        }, 1000);
      });
    }
    // else {
    //   this.playingAudio.pause();
    //   this.audioAttachments[index].pause = true;
    //   clearInterval(this.playerTimeout)
    // }
  }

  async voiceRecord() {
    navigator.permissions.query({ name: 'microphone' as PermissionName }).then((permissionStatus) => {
      if (permissionStatus.state === "denied") {
        this.helperService.showToaster("error", "Microphone access denied. Please enable it in your browser settings.");
        return;
      }
      this.isRecording = !this.isRecording;
      if (this.isRecording) {
        // navigator.mediaDevices
        //   .getUserMedia({
        //     audio: true,
        //   })
        //   .then((stream) => {
        //     this.recorder = RecordRTC(stream, {
        //       type: 'audio',
        //       mimeType: 'audio/wav',
        //       disableLogs: true,
        //     });
        //     this.recorder.startRecording();
        //     this.playerTimeout = setInterval(() => {
        //       this.recordingTime += 1;
        //       this.playingFormatedTime = this.formatTime(this.recordingTime);
        //     }, 1000);
        //   })
        //   .catch(error => {
        //     this.helperService.showToaster('error', error);
        //   });
        navigator.mediaDevices.getUserMedia({
          audio: {
            echoCancellation: true,
          }
        }).then(stream => {
          try {
            this.audioBlobs = [];
            this.capturedStream = stream;

            // Use the extended MediaRecorder library
            this.mediaRecorder = new MediaRecorder(stream);

            // Add audio blobs while recording 
            this.mediaRecorder.addEventListener('dataavailable', event => {
              this.audioBlobs.push(event.data);
            });

            this.mediaRecorder.start();
            this.playerTimeout = setInterval(() => {
              this.recordingTime += 1;
              this.playingFormatedTime = this.formatTime(this.recordingTime);
            }, 1000);
          } catch (error) {
            this.helperService.showToaster('error', error);
          }
        }).catch((e) => {
          console.error(e);
        });
      } else {
        // this.recorder.stopRecording(() => {

        //   this.isVoiceUploading = true;

        //   // refresh recorder box
        //   this.showRecorder = false;
        //   setTimeout(() => {
        //     this.showRecorder = true;
        //   }, 0);
        //   const blob = this.recorder.getBlob();
        //   const formData = new FormData();
        //   formData.append('file', blob);
        //   clearInterval(this.playerTimeout)
        //   this.httpService.uploadAttachment(formData, config.category.inspection, this.selectedInspection._id).then(
        //     (res: any) => {
        //       this.selectedInspection.attachments.push({
        //         name: res.url.split('/').pop(),
        //         url: res.url,
        //         type: 'voice',
        //         recordingTime: this.recordingTime,
        //         createdBy: this.helperService.getCompany().userName,
        //         createdAt: res.uploadAt,
        //         createdAtTz: this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(res.uploadAt).getTime()), datetimeFormat.mmmdyyhhmmaa),
        //       });
        //       this.updateInspection(null, null, null, null, this.selectedInspection.attachments)
        //       this.recordingTime = 0;
        //       this.playingFormatedTime = '';
        //       this.isVoiceUploading = false;
        //     },
        //     (err) => {
        //       this.recordingTime = 0;
        //       this.playingFormatedTime = '';
        //       this.helperService.showToaster('error', err);
        //       this.isVoiceUploading = false;
        //     }
        //   );
        // });
        {
          if (!this.mediaRecorder) {
            return;
          }

          this.mediaRecorder.addEventListener('stop', () => {
            const mimeType = this.mediaRecorder.mimeType;
            const audioBlob = new Blob(this.audioBlobs, { type: mimeType });
            const formData = new FormData();
            formData.append('file', audioBlob);
            clearInterval(this.playerTimeout)
            this.httpService.uploadAttachment(formData, config.category.inspection, this.selectedInspection._id).then(
              (res: any) => {
                this.selectedInspection.attachments.push({
                  name: res.url.split('/').pop(),
                  url: res.url,
                  type: 'voice',
                  recordingTime: this.recordingTime,
                  createdBy: this.helperService.getCompany().userName,
                  createdAt: res.uploadAt,
                  createdAtTz: this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(res.uploadAt).getTime()), datetimeFormat.mmmdyyhhmmaa),
                });
                this.updateInspection(null, null, null, null, this.selectedInspection.attachments);
                this.refreshInspectionItems();
                this.recordingTime = 0;
                this.playingFormatedTime = '';
                this.isVoiceUploading = false;
              },
              (err) => {
                this.recordingTime = 0;
                this.playingFormatedTime = '';
                this.helperService.showToaster('error', err);
                this.isVoiceUploading = false;
              }
            );

            if (this.capturedStream) {
              this.capturedStream.getTracks().forEach(track => track.stop());
            }

          });

          this.mediaRecorder.stop();

        }
      }
    })
  }

  formatTime(seconds: number): string {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    // Pad hours, minutes, and seconds with leading zeros if they are less than 10
    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(remainingSeconds).padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }

  isItemRequired(itemId: string): boolean {
    if (this.inspectionDifficulty === 'easy') {
      return false;
    }

    let item;
    for (const category of this.actualInspection?.category || []) {
      item = category.inspectionItems.find(ins => ins._id === itemId);
      if (item) break;
    }

    if (!item) return false;

    if (item.isRequired) {
      return true;
    }

    if (item.isMediaRequired) return true;

    if (this.actualInspection?.mediaForYRItems &&
      (item.colorIndex === 1 || item.colorIndex === 2)) {
      return true;
    }

    return false;
  }

  isOverviewImageRequired(): boolean {
    if (this.inspectionDifficulty === 'easy') {
      return false;
    }

    return this.actualInspection?.overviewImgsRequired || false;
  }

  isSelectedInspectionResultRequired(): boolean {
    if (this.inspectionDifficulty === 'easy') {
      return false;
    }
    if (!this.selectedInspection) return false;

    return this.selectedInspection.isRequired;
  }

  isRequiredFieldEmpty(itemId: string): boolean {
    if (this.inspectionDifficulty === 'easy') {
      return false;
    }

    let item;
    for (const category of this.actualInspection?.category || []) {
      item = category.inspectionItems.find(ins => ins._id === itemId);
      if (item) break;
    }

    if (!item) return false;

    if (item.colorIndex < 0 || item.colorIndex > 2) return false;

    if ((item.isRequired && item.isMediaRequired) ||
      (!item.isRequired && item.isMediaRequired)) {
      return !item.attachments || item.attachments.length === 0;
    }

    if (item.isRequired && !item.isMediaRequired) {
      if (!this.actualInspection?.mediaForYRItems) {
        return false;
      }
      else if (item.colorIndex === 1 || item.colorIndex === 2) {
        return !item.attachments || item.attachments.length === 0;
      }
    }

    if (this.actualInspection?.mediaForYRItems &&
      !item.isRequired && !item.isMediaRequired &&
      (item.colorIndex === 1 || item.colorIndex === 2)) {
      return !item.attachments || item.attachments.length === 0;
    }

    return false;
  }

  isSelectedInspectionRequired(): boolean {
    if (this.inspectionDifficulty === 'easy') {
      return false;
    }
    if (!this.selectedInspection) return false;

    if (this.selectedInspection.isMediaRequired) return true;

    if (this.actualInspection?.mediaForYRItems &&
      (this.selectedInspection.status === 1 || this.selectedInspection.status === 2)) {
      return true;
    }

    if (this.selectedInspection.isRequired && this.actualInspection?.mediaForYRItems) {
      return this.selectedInspection.status === 1 || this.selectedInspection.status === 2;
    }

    return false;
  }

  getItemStatus(itemId: string): number {
    for (const category of this.actualInspection?.category || []) {
      const item = category.inspectionItems.find(ins => ins._id === itemId);
      if (item) return item.colorIndex;
    }
    return -1;
  }

  getAttachmentCount(itemId: string): number {
    for (const category of this.actualInspection?.category || []) {
      const item = category.inspectionItems.find(ins => ins._id === itemId);
      if (item && item.attachments) return item.attachments.length;
    }
    return 0;
  }

  hasAttachments(itemId: string): boolean {
    return this.getAttachmentCount(itemId) > 0;
  }

  getOverviewImageSrc(imageId: string): string {
    return this.vehicle?.vehicleImgs && this.vehicle?.vehicleImgs[imageId] 
      ? this.vehicle.vehicleImgs[imageId] 
      : '';
  }

  updateMissingItems() {
    if (this.showMissingFieldsError) {
      const currentMissingItems = this.validateInspection();
      
      const groupedMissingItems = currentMissingItems.reduce((acc, item) => {
        if (!acc[item.categoryType]) {
          acc[item.categoryType] = {
            type: item.categoryType,
            icon: item.categoryIcon,
            items: []
          };
        }
        acc[item.categoryType].items.push(item);
        return acc;
      }, {});
      
      this.missingInspectionItems = Object.values(groupedMissingItems);
      
      if (this.missingInspectionItems.length === 0) {
        this.showMissingFieldsError = false;
        this.isFilterViewActive = false
      }
    } else {
      this.missingInspectionItems = [];
      
      if (this.missingInspectionItems.length === 0) {
        this.showMissingFieldsError = false;
        this.isFilterViewActive = false
      }
    }
  }

  applyFilterBarStyling(isActive: boolean): void {
    const filterElement = document.querySelector('.filter-section');
    if (filterElement) {
      const textElements = filterElement.querySelectorAll('.filter-text, .filter-count');
      const filterIcon = filterElement.querySelector('.filter-icon');
      const infoIcon = filterElement.querySelector('.filter-info-icon');
  
      if (isActive) {
        textElements.forEach(el => {
          (el as HTMLElement).style.color = '#FF3E3E';
          (filterElement as HTMLElement).style.borderRadius = '6px';
          (filterElement as HTMLElement).style.border = '1px solid #FFB1B1';
        });
  
        if (filterIcon) {
          (filterIcon as HTMLImageElement).src = 'assets/img/icon/filtered-info.svg';
          (filterIcon as HTMLImageElement).style.width = '32px';
          (filterIcon as HTMLImageElement).style.height = '32px';
          (filterIcon as HTMLImageElement).style.filter = 'none';
        }
  
        if (infoIcon) {
          (infoIcon as HTMLImageElement).style.filter = 'invert(27%) sepia(94%) saturate(5483%) hue-rotate(343deg) brightness(97%) contrast(114%)';
        }
      } else {
        textElements.forEach(el => {
          (el as HTMLElement).style.color = '#000000A3';
          (filterElement as HTMLElement).style.borderRadius = '6px';
          (filterElement as HTMLElement).style.border = '1px solid #0000001F';
        });
  
        if (filterIcon) {
          (filterIcon as HTMLImageElement).src = 'assets/img/icon/filter.svg';
          (filterIcon as HTMLImageElement).style.filter = 'none';
        }
  
        if (infoIcon) {
          (infoIcon as HTMLImageElement).style.filter = 'none';
        }
      }
    }
  }
  
  toggleMissingFieldsView(): void {
    this.isFilterViewActive = !this.isFilterViewActive;
    this.applyFilterBarStyling(this.isFilterViewActive);
  }

  getTotalMissingItemsCount(): number {
    let totalCount = 0;
    
    if (this.isOverviewImageRequired() && !this.isOverviewImagesComplete()) {
      const missingImagesCount = this.inspectionOverview.filter(img => !img.imgSrc).length;
      totalCount += missingImagesCount;
    }
    
    for (const category of this.actualInspection?.category || []) {
      for (const item of category.inspectionItems) {
        let isMissing = false;
        
        if (item.isRequired) {
          const hasStatus = item.colorIndex === 0 || item.colorIndex === 1 || item.colorIndex === 2;
          if (!hasStatus) {
            isMissing = true;
          }
        }
        
        const hasAttachments = item.attachments && item.attachments.length > 0;
        const hasStatus = item.colorIndex === 0 || item.colorIndex === 1 || item.colorIndex === 2;
        
        if (hasStatus) {
          if (item.isMediaRequired && !hasAttachments) {
            isMissing = true;
          }
          else if (this.actualInspection?.mediaForYRItems &&
            (item.colorIndex === 1 || item.colorIndex === 2) &&
            !hasAttachments) {
            isMissing = true;
          }
        }
        else if (item.isMediaRequired && !hasStatus) {
          isMissing = true;
        }
        
        if (isMissing) {
          totalCount++;
        }
      }
    }
    
    return totalCount;
  }


  validateInspection(): { 
    index: number, 
    name: string, 
    requirement: string, 
    categoryType: string,
    categoryIcon?: string,
    id: string, 
    isOverviewItem?: boolean,
    missingImages?: any[]
  }[] {
  const missingItems = [];
  let index = 1;

  if (this.actualInspection?.overviewImgsRequired) {
    const missingImages = this.inspectionOverview.filter(img => !img.imgSrc);
    if (missingImages.length > 0) {
      missingItems.push({
        index: index++,
        name: this.currentLang === 'fr' ? 'Aperçu du véhicule' : 'Vehicle Overview',
        requirement: this.currentLang === 'fr' ? 'Upload Media' : 'Upload Media',
        categoryType: this.currentLang === 'fr' ? 'Aperçu' : 'Overview',
        categoryIcon: 'assets/img/icon/camera.svg',
        id: 'overview',
        isOverviewItem: true,
        missingImages: missingImages.map(img => ({
          id: img.id,
          label: this.currentLang === 'fr' ? (img.labelFR || img.label) : (img.label || img.labelFR)
        }))
      });
    }
  }

  for (const category of this.actualInspection?.category || []) {
    for (const item of category.inspectionItems) {
      let requirements = '';

      if (item.isRequired) {
        const hasStatus = item.colorIndex === 0 || item.colorIndex === 1 || item.colorIndex === 2;
        if (!hasStatus) {
          requirements = 'Item Required';
        }
      }

    const hasAttachments = item.attachments && item.attachments.length > 0;
    const hasStatus = item.colorIndex === 0 || item.colorIndex === 1 || item.colorIndex === 2;

    if (hasStatus) {
      if (item.isMediaRequired && !hasAttachments) {
        requirements = (this.currentLang === 'fr' ? 'Media Upload' : 'Media Upload');
      }
      else if (this.actualInspection?.mediaForYRItems &&
        (item.colorIndex === 1 || item.colorIndex === 2) &&
        !hasAttachments) {
        requirements = (this.currentLang === 'fr' ? 'Media Upload' : 'Media Upload');
      }
    }
    else if (item.isMediaRequired && !hasStatus) {
      requirements = (this.currentLang === 'fr' ? 'Media Upload' : 'Media Upload');
    }

      if (requirements.length > 0) {
        missingItems.push({
          index: index++,
          name: this.currentLang === 'fr' ? (item.titleFR || item.title) : (item.title || item.titleFR),
          requirement: requirements,
          categoryType: this.currentLang === 'fr' ? (category.titleFR || category.title) : (category.title || category.titleFR),
          categoryIcon: category.iconUrl || category.icon,
          id: item._id 
        });
      }
    }
  }

  return missingItems;
  }

  onMissingOverviewFileSelected(id, event) {
    this.stopImmediateUpload = true;
    let files;
    if (event?.target?.files) {
      files = event.target.files;
    } else if (event?.srcElement?.files) {
      files = event.srcElement.files;
    } else if (event?.currentTarget?.files) {
      files = event.currentTarget.files;
    } else if (event?.files) {
      files = event.files;
    }

    if (files && files[0]) {
      let fileName = trim(files[0].name);
      fileName = fileName.replaceAll('-', '');
      if (this.isIphone) {
        fileName = `${fileName}${new Date().getTime()}`;
      }
      
      const formData = new FormData();
      formData.append('file', files[0], fileName);
      
      this.httpService.uploadAttachment(formData, config.category.inspection, `${this.estimateId}#${this.inspectionId}`).then(
        (res: any) => {
          const url = res.url;
          this.vehicle = {
            ...this.vehicle,
            vehicleImgs: {
              ...this.vehicle.vehicleImgs,
              [id]: url
            }
          };
          
          this.updateVehicleOverviewSection();
          this.updateMissingItems(); 
          this.stopImmediateUpload = false;
          
          if (this.isOverlaySidebarOpen && this.isOverviewImagesComplete()) {
            this.toggleInspection();
          }
        },
        (err) => {
          this.stopImmediateUpload = false;
          this.helperService.showToaster('error', err);
        });
      }
  }

  clearErrorHighlights() {
    document.querySelectorAll('.img-block.missing-required-field').forEach(element => {
      element.classList.remove('missing-required-field');
    });

    this.inspections.forEach(inspection => {
      inspection.items.forEach(inspectionItem => {
        inspectionItem.showError = false;
        inspectionItem.errorMessage = '';
      });
    });
  }

  // set condition boxes
  setConditions(toUpdateWidth = false) {
    const allConditions = [];
    this.actualInspection?.category?.forEach(cat => {
      const inspections = cat?.inspectionItems;
      let conditions = [];
      inspections?.forEach(i => {
        conditions = i?.conditions?.map(c => {
          let w;
          if (toUpdateWidth) {
            w = this.setWidth(c.name);
          } else {
            this.allConditions.forEach(inspection => {
              inspection.conditions.forEach(condition => {
                if (condition._id === c._id) {
                  w = {
                    dynamicWidth: condition.width,
                    row: condition.row,
                  };
                }
              })
            });
          }
          return {
            ...c,
            width: w.dynamicWidth ?? w.width,
            row: w.row,
          }
        })
        if (toUpdateWidth) {
          conditions = this.widenWidth(conditions);
        }
        allConditions.push({
          id: i._id,
          conditions
        })
      });
    })
    this.allConditions = allConditions;
  }

setMeasurements() {
  const measurementsMap = new Map();

      this.selectedInspection?.measurementSection?.forEach(section => {
        if (!measurementsMap.has(section.name)) {
          measurementsMap.set(section.name, {
            name: section.name,
            units: [],
            id: this.selectedInspection._id,
            inspectionItemId: this.selectedInspection.itemId,
          });
        }

        section?.notes?.forEach(note => {
          measurementsMap.get(section.name).units.push({ text: note.text, _id: note._id });
        });
      });

  this.allMeasurements = Array.from(measurementsMap.values());  

  this.actualInspection.category.forEach((cat) => {
    cat?.inspectionItems?.forEach(i => {
      i.measurement?.forEach((section) => {
        const matchingMeasurement = this.allMeasurements?.find(item => item.name === section.name);

        if (matchingMeasurement) {
          matchingMeasurement.value = section?.value || null;
        }
      });
    });
  });

}

restrictInputLength(event: KeyboardEvent): void {
  const inputElement = event.target as HTMLInputElement;

  const allowedKeys = [
    'Backspace',
    'Delete',
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown',
    'Tab',
    'Enter',
    'Home',
    'End',
    'Escape',
  ];

  const isNumeric = /^[0-9]$/.test(event.key);
  const isDot = event.key === '.';
  const isAllowedKey = allowedKeys.includes(event.key);

  // Prevent multiple dots
  const hasDot = inputElement.value.includes('.');

  if (
    inputElement.value.length >= 10 &&
    !isAllowedKey &&
    !isNumeric &&
    !(isDot && !hasDot)
  ) {
    event.preventDefault();
    return;
  }

  // Disallow non-numeric/non-allowed/non-single-dot input
  if (!isNumeric && !isAllowedKey && !(isDot && !hasDot)) {
    event.preventDefault();
  }
}

getUnitStyles(unitId: string, units: any): { [key: string]: string } {
  const isSelected = this.measurementInspectionIds.includes(unitId);
  const isSingleUnit = units?.length === 1;

  return {
    border: isSingleUnit ? 'none' : isSelected ? '1px solid #1677FF' : '1px solid #00000026',
    color: isSelected && !isSingleUnit ? '#1677FF' : 'inherit',
    padding: isSingleUnit ? '0px' : '16px',
  };
}

handleUnitClick(unit: string, name: string, id: string, unitsArr: any, inspectionId: string,value:string) {
  let data = { unit, name, id, inspectionId };

  const objIds = unitsArr.map(item => item._id);

  const isSelected = this.measurementInspectionIds.includes(id);

  if (isSelected) {
    this.measurementInspectionIds = this.measurementInspectionIds.filter(existingId => existingId !== id);

    data = { unit: '', name, id: '', inspectionId };
  } else {
    this.measurementInspectionIds = [...this.measurementInspectionIds, id];

    this.measurementInspectionIds = this.measurementInspectionIds.filter(existingId => !objIds.includes(existingId) || existingId === id);
  }

    if (value && data.unit === '' && data.id === '') {
    const defaultUnit = unitsArr[0]?.text;
    const defaultUnitId = unitsArr[0]?._id;

    data.unit = defaultUnit;
    data.id = defaultUnitId;
  }

  const existingIndex = this.measurements.findIndex((item) => item.name === name);

  if (existingIndex !== -1) {
    if (!value && data.unit === '' && data.id === '') {
      this.measurements.splice(existingIndex, 1);
    } else {
      this.measurements[existingIndex] = {
        ...this.measurements[existingIndex],
        value: !this.measurements[existingIndex].value ? "0" : this.measurements[existingIndex].value,
        unit: data.unit,
        id: data.id,
        inspectionId: data.inspectionId
      };
    }
  } else {
    if (value || (data.unit && data.id)) {
      this.measurements = [...this.measurements, data];
    }
  }
  
  this.debouncedUpdateInspection();
}

handleInputChange(event: Event, name: string, unitsArr: any[], inspectionId: string): void {
  const inputElement = event.target as HTMLInputElement;
  
  if (inputElement.value.length > 10) {
    inputElement.value = inputElement.value.slice(0, 10);
  }

  const inputValue = parseFloat(inputElement.value) || 0;

  const defaultUnit = unitsArr.length > 0 ? unitsArr[0].text : '';
  const defaultUnitId = unitsArr.length > 0 ? unitsArr[0]._id : null;
  const existingIndex = this.measurements.findIndex((item) => item.name === name && item.inspectionId === inspectionId);

  if (existingIndex !== -1) {
    this.measurements[existingIndex] = {
      ...this.measurements[existingIndex],
      value: inputValue,
      unit: this.measurements[existingIndex].unit || defaultUnit,
      id: this.measurements[existingIndex].id || defaultUnitId,
      inspectionId
    };
  } else {
    this.measurements = [
      ...this.measurements,
      {
        name,
        value: inputValue,
        unit: defaultUnit,
        id: defaultUnitId,
        inspectionId
      },
    ];
  }
}

onInputBlur(): void {
  this.updateInspection(this.selectedInspection._id, null, this.selectedInspection.status);
}


  setWidth(name: string) {
    const dynamicWidth = Math.ceil(name.length * 2.5) + 1;
    this.totalWidthAssigned += dynamicWidth;
    return { row: Math.ceil(this.totalWidthAssigned / this.rowMaxWidth), dynamicWidth };
  }

  widenWidth(data) {
    const totalRows = data.reduce((acc, val) => {
      const rownum = val.row
      !acc[rownum] ? acc[rownum] = 1 : acc[rownum] += 1;
      return acc;
    }, [])
    let row;
    for (let rownum = 0; rownum < totalRows.length; rownum++) {
      if (totalRows[rownum] !== null && totalRows[rownum] > 0) {
        row = data.filter(d => d.row === rownum)
      } else {
        continue;
      }
      const accumlatedWidth = row.reduce((acc, val) => {
        acc += val.width;
        return acc;
      }, 0);
      const diff = this.rowMaxWidth - accumlatedWidth;
      if (diff > 1) {
        const toAdd = (diff / row.length);
        row = row.map(r => ({ ...r, width: r.width += toAdd }));
      } else if (diff < 1) {
        const toSubtract = diff / row.length;
        row = row.map(r => ({ ...r, width: r.width += toSubtract }));
      }
    }
    return data
  }

  async completeInspection(): Promise<void> {
    if (this.actualInspection) {
      this.actualInspection.inspectionStatus = this.inspectionStatuses.COMPLETED;
      try {
        await this.httpService.updateOrderInspection(this.actualInspection);

        this.dataService.sendData(
          this.dataService.typePassData('update-inspection-status', {
            inspectionId: this.inspectionId,
            status: this.inspectionStatuses.COMPLETED
          })
        );
      } catch (error) {
        this.helperService.showToaster('error', 'Failed to complete inspection');
      }
    }

    return Promise.resolve();
  }

  handleDone() {
    if (this.inspectionDifficulty === 'pro' && !this.isReadOnly) {
      const missingItems = this.validateInspection();
      if (missingItems.length > 0) {
        this.showMissingFieldsError = true;
        this.isFilterViewActive = true;
  
        const groupedMissingItems = missingItems.reduce((acc, item) => {
          if (!acc[item.categoryType]) {
            acc[item.categoryType] = {
              type: item.categoryType,
              icon: item.categoryIcon,
              items: []
            };
          }
  
          acc[item.categoryType].items.push(item);
          return acc;
        }, {});
  
        this.missingInspectionItems = Object.values(groupedMissingItems);
        this.applyFilterBarStyling(this.isFilterViewActive);
        return;
      }
    }
    this.completeInspection().then(() => {
      this.handleClose();
      if (this.dataService.isTireStorage2Enabled && this.isBackToStoreDetails) {
        this.router.navigate([`/tech/store-tire/${this.estimateId}/${this.serviceId}/item/${this.itemId}`],
          { queryParams: { lang: this.currentLang, isTakeStorageLocation: true } });
      } else if (this.isFromTech) {
        this.router.navigate([`/tech/order/${this.estimateId}`], { queryParams: { lang: this.currentLang } });
      }
    });
  }

  handleClose() {
    if (this.inspectionDifficulty === 'pro' && !this.isReadOnly) {
      const missingItems = this.validateInspection();
      if (missingItems.length > 0) {
        this.showMissingFieldsError = true;

        const groupedMissingItems = missingItems.reduce((acc, item) => {
          if (!acc[item.categoryType]) {
            acc[item.categoryType] = {
              type: item.categoryType,
              icon: item.categoryIcon,
              items: []
            };
          }
          acc[item.categoryType].items.push(item);
          return acc;
        }, {});

        this.missingInspectionItems = Object.values(groupedMissingItems);
        return;
      }
    }
    this.closeModalEvent.emit({ isSuccess: true, data: { inspection: this.actualInspection } });
    this.handleCloseInspection()
  }

  handleCloseInspection() {
    if (this.isModal) {
      this.closeModalEvent.emit({ isSuccess: true, data: { inspection: this.actualInspection } });
    } else {
      if (this.dataService.isTireStorage2Enabled && this.isBackToStoreDetails) {
        this.router.navigate([`/tech/store-tire/${this.estimateId}/${this.serviceId}/item/${this.itemId}`],
          { queryParams: { lang: this.currentLang, isTakeStorageLocation: true } });
      } else {
        this.router.navigate([`/tech/order/${this.estimateId}`], { queryParams: { lang: this.currentLang } });
      }
    }
  }

  ngOnDestroy() {
    this.helperService.hideBottomDetailsInTechApp.next(false);
    this.subscriptions.forEach(subscription => subscription.unsubscribe())
  }
}
